export const slugify = (str: string): string => {
  const nonLetterCharacters = /[^A-Za-z0-9]/g;
  return str.replace(nonLetterCharacters, "").toLowerCase();
};
